import { saveAs } from 'file-saver';
import { QuestionObj } from '../types/quiz';

export function arrayToCSV(data: (string | number)[][]): string {
  return data
    .map((row) =>
      row
        .map((item) => {
          const value = String(item);
          const needsQuotes =
            value.includes(',') ||
            value.includes('"') ||
            value.includes('\n') ||
            value.includes('\r');
          const escapedValue = value.replace(/"/g, '""');
          return needsQuotes ? `"${escapedValue}"` : value;
        })
        .join(','),
    )
    .join('\n');
}

export function exportToTSV(questions: QuestionObj[], quizName: string) {
  const header = 'quiz name\tquestion number\tquestion\tanswer\n';
  const sortedQuestions = questions.sort(
    (a, b) => (a.number ?? 0) - (b.number ?? 0),
  );
  const rows = sortedQuestions
    .map((q, index) => `${quizName}\t${index + 1}\t${q.question}\t${q.answer}`)
    .join('\n');
  const tsvContent = header + rows;
  const blob = new Blob([tsvContent], { type: 'text/tsv;charset=utf-8;' });
  saveAs(blob, quizName + '_quiz.tsv');
}

export function exportToCanvaCSV(questions: QuestionObj[], quizName: string) {
  const questionsAndAnswers = questions
    .sort((a, b) => (a.number ?? 0) - (b.number ?? 0))
    .flatMap((q, index) => [
      `${index + 1}. ${q.question}`,
      `${index + 1}. ${q.answer}`,
    ]);
  const header = [
    'QuizName',
    ...Array.from({ length: questionsAndAnswers.length / 2 }, (_, i) => [
      `q${i + 1}`,
      `a${i + 1}`,
    ]).flat(),
  ];
  const csvObj = [header, [quizName, ...questionsAndAnswers]];
  const blob = new Blob([arrayToCSV(csvObj)], {
    type: 'text/tsv;charset=utf-8;',
  });
  saveAs(blob, quizName + '_quiz.csv');
}
